@if (isQuarterCloseEnabled() && isClosingPanelEnabled()) {
  <aux-workflow-panel
    className="mb-7"
    [workflowName]="workflowName"
    [processing]="iCloseMonthsProcessing()"
    [hasUserPermissions]="userHasLockInvestigatorDataPermission()"
  />
}

@if ((isProtocolVersionLoading$ | async) === false) {
  <aux-protocol-section
    className="mb-4"
    [versionOptions]="protocolVersionOptions"
    [patientOptions]="patientGroupOptions"
    [hideAmendment]="true"
    [alwaysShowSection]="true"
    [template]="exportButton"
    (formReady)="onProtocolFormReady($event)"
  />
}

<ng-template #exportButton>
  <div class="ml-4 flex justify-between">
    <div class="flex items-center space-x-4">
      @let isExportProcessing = (isBtnLoading('export') | async)!;

      <aux-export-excel-button
        [clickFN]="onExportPatientBudget.bind(this)"
        [loading]="isExportProcessing"
        [spinnerSize]="7"
        [disabled]="isExportProcessing"
        pendoTag="patient-protocol-excel-export-button"
      />
    </div>
  </div>
</ng-template>

<div class="my-4 flex items-center justify-between">
  <div class="flex items-center">
    <div class="mr-2 text-xs">Site:</div>
    <aux-multiple-site-select
      [(appliedSelectedSiteIDs)]="selectedSiteIDs"
      (applySelection)="onApplySelection($event)"
      class="w-[300px]"
    />
  </div>
  <div class="flex items-center">
    <aux-toggle-currency (nameSelectedCurrency)="selectedCurrency.set($event)" />
    <aux-patient-protocol-actions />
  </div>
</div>

<aux-site-cost-summary-table
  [selectedCurrency]="selectedCurrency()"
  [costType]="selectedCostType()"
  [protocolVersionId]="selectedProtocolVersion()"
  [patientGroupId]="selectedPatientGroup()"
  [siteIds]="siteIdsFc.value || []"
/>
